import { useEffect, useState } from 'react';

import { Input, SidebarButtons, Spinner } from '@netfront/ui-library';

import { useApiKeyContext } from '../../../../contexts';
import { useToast, useUpdateApiKey } from '../../../../hooks';
import { IApiKey } from '../../../../interfaces';

const AnalyticsView = () => {
  const { dispatch, state: apiKeys = [] } = useApiKeyContext();
  const { handleToastError, handleToastSuccess } = useToast();

  const [selectedApiKey, setSelectedApiKey] = useState<IApiKey | undefined>(apiKeys.find(({ isSelected }) => isSelected));
  const [googleMeasurementKey, setGoogleMeasurementKey] = useState<string>('');
  const [pixelCode, setPixelCode] = useState<string>('');

  const { handleUpdateApiKey, isLoading: isUpdatApiKeyLoading = false } = useUpdateApiKey({
    onCompleted: ({ apiKey: returnedApiKey }) => {
      setSelectedApiKey(returnedApiKey);

      dispatch({
        payload: {
          apiKey: returnedApiKey,
        },
        type: 'updateApiKey',
      });

      handleToastSuccess({
        message: 'Api key successfully updated.',
      });
    },
    onError: (error) => {
      handleToastError({
        error,
        shouldUseFriendlyErrorMessage: true,
      });
    },
  });
  
  const handleSave = () => {
    handleUpdateApiKey({
      id: Number(selectedApiKey?.id),
      googleMeasurementKey,
      pixelCode,
    });
  };

  useEffect(() => {
    if (!apiKeys.length) {
      return;
    }

    setSelectedApiKey(apiKeys.find(({ isSelected }) => isSelected));
  }, [apiKeys]);


  useEffect(() => {
    if (!selectedApiKey) {
      return;
    }

    setGoogleMeasurementKey(selectedApiKey.googleMeasurementKey ?? '');
    setPixelCode(selectedApiKey.pixelCode ?? '');

  }, [selectedApiKey])

  if (!selectedApiKey) {
    return null;
  }



  const isLoading = isUpdatApiKeyLoading;

  return (
    <>
      <Spinner isLoading={isLoading} />

      <div className="flex flex-col p-4">
        <Input
          id="google-measurement-id"
          labelText="Google Measurement Id"
          name="google-measurement-id"
          tooltipText="Add in the Google Measurement Id to start tracking different feature usage in your project Google Analytics account"
          type="text"
          value={googleMeasurementKey}
          isLabelSideBySide
          onChange={({ target: { value } }) => {
            setGoogleMeasurementKey(value)
          }}
        />

        <Input
          id="pixel-cde"
          labelText="Meta pixel"
          name="pixel-cde"
          tooltipText="Add in the Meta pixel to start tracking different feature usage in your project Google Analytics account"
          type="text"
          value={pixelCode}
          isLabelSideBySide
          onChange={({ target: { value } }) => {
            setPixelCode(value)
          }}
        />
        <SidebarButtons
          onSave={handleSave}
          onSaveButtonType="button"
        />
      </div>
    </>
  );
};

export { AnalyticsView };
